'use strict';

var productTile = require('grocery/product-tile');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');

        $results
            .find('.' + $(this)[0].className.replace(/ /g, '.'))
            .addClass('active');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function updatePageHistory(updatedUrl, pageSize, filterShow) {
    var currentUrl = window.location.href;
    if (window.location.href.includes('&srule')) {
        currentUrl = window.location.href.split('&srule')[0];
    } else if (window.location.href.includes('&start')) {
        currentUrl = window.location.href.split('&start')[0];
    }

    var incomingParams = updatedUrl.split('&');
    var totalSize;

    if (filterShow) {
        totalSize = 0;
    } else {
        totalSize = 16;
    }

    var urlParams = '';
    incomingParams.forEach(function(incoming) {
        if (incoming.includes('start')) totalSize += parseInt(incoming.slice(-3).replace(/\D/g, ''), 10);
        if (incoming.includes('srule')) urlParams = incoming + '&';
    });
    urlParams += 'start=0&sz=' + totalSize;
    history.pushState(null,null, currentUrl + '&' + urlParams);

}

function infiniteScroll() {
    var moreButton = document.querySelector('.more');
    var productGrid = document.querySelector('.product-grid');
    if (!moreButton || !productGrid) return;
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting && productGrid.childElementCount > 0) {
                moreButton.click();
            }
        });
    });
    observer.observe(moreButton);
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.execute-btn-wrapper, .modal-background').show();
        });
    },

    closeRefinments: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('.refinement-bar, .modal-background').hide();
        });

        $('.container').on('click', '.execute-button', function () {
            $('.refinement-bar').hide();
        });


    },

    resize: function () {
        // Close refinement bar if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar').hide();
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    var showMoreUrl = $('.filter').data('url');
                    var pageSize = $('.more').data('pagesize');
                    updatePageHistory(showMoreUrl,pageSize,1);
                    setTimeout(function() {
                        window.location.reload();
                    },500);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    resetProductGridObserver: function() {
        $(document).on('search:showMore',function() {
            console.log('calling function scroll');
            setTimeout(function() {
                infiniteScroll();
            }, 1000);
        });
    },

    showMore: function () {
        infiniteScroll();
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            var pageSize = $(this).data('pagesize');
            updatePageHistory(showMoreUrl, pageSize);
            e.preventDefault();

            $.spinner().start();
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $(document).trigger('search:showMore', e);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .refinement-bar a.reset, .filter-value button, .swatch-filter button, .execute-button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results .result-count'));
            $('.show-more-content').remove();
        });
    },

    colorAttribute: function () {
        $(document).on('click', '.color-swatches a', function (e) {
            e.preventDefault();

            var swatchImg = $(e.currentTarget).data('swatchimg');
            var $productContainer = $(this).closest('.set-item'); // Need to check and see what classes a product set tile has if any?

            if (!$productContainer.length) {
                $productContainer = $(this).closest('.grid-tile');
            }

            var currentImg = $($productContainer).find('.tile-image').attr('src');

            if ($(this).attr('disabled') || currentImg === swatchImg) {
                return;
            }

            $($productContainer).find('.tile-image').attr('src', swatchImg);
        });
    },

    initProductTile: function () {
        productTile.init();
    }
};
